<script>
import {URL_QUERIES} from '@/const';
import {mapActions} from 'vuex';
import {CONFIRM_ACCOUNT_DELETE} from '@/store/actionTypes';
import LoaderComponent from '@/components/LoaderComponent.vue';
import AppLink from '@/components/base-components/AppLink.vue';
import {HOME} from '@/pages';

export default {
  name: 'ConfirmAccountDeletion',
  components: {AppLink, LoaderComponent},
  data() {
    return {
      processing: false,
      error: null,
    };
  },
  computed: {
    HOME() {
      return HOME;
    },
    email() {
      return this.$route.query[URL_QUERIES.EMAIL];
    },
    expires() {
      return this.$route.query[URL_QUERIES.EXPIRES];
    },
    signature() {
      return this.$route.query[URL_QUERIES.SIGNATURE];
    },
  },
  methods: {
    ...mapActions({
      deleteRequest: CONFIRM_ACCOUNT_DELETE,
    }),
    confirmAccountDeletion() {
      this.processing = true;
      this.deleteRequest({
        email: this.email,
        expires: this.expires,
        signature: this.signature,
      })
          .then(() => {})
          .catch(() => {
            this.error = true;
          })
          .finally(() => {
            this.processing = false;
          });
    },
  },
  mounted() {
    this.confirmAccountDeletion();
  },
};

</script>

<template>
  <div class="delete_account__wrapper">
    <template v-if="processing">
      <div>
        <h3>Please wait while we delete your account</h3>
        <p>{{ email }}</p>
      </div>
      <div>
        <loader-component/>
      </div>
    </template>
    <template v-else>
      <template v-if="error">
        <div>
          <h3>Failed to delete your account</h3>
          <p>Please contact support</p>
        </div>
      </template>
      <template v-else>
        <h1>Your account has been deleted successfully</h1>
      </template>
      <app-link :to="HOME" class="home_button">Go to Home</app-link>
    </template>
  </div>
</template>

<style scoped lang="scss">
.delete_account__wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 3rem;
  height: 100vh;
  font-style: normal;
  font-weight: normal;
  .home_button{
    background: var(--settings-body-text-color);
    color: var(--settings-body-background);
    padding: .5rem 2rem;
    border-radius: .3rem;
    text-decoration: none;
    font-weight: 400;
    letter-spacing: 1.3px;
    transition: letter-spacing  .3s linear, font-weight .3s linear;
    &:hover{
      font-weight: 900;
      letter-spacing: 1px;
    }
  }
}
</style>
